module.exports = __webpack_public_path__ + "img/key_features--cardiac_chair.0ebde0ae.png";